import { initializeApp } from "firebase/app"; 
import { getAnalytics } from "firebase/analytics"; 
import { getFirestore } from "firebase/firestore"; 
import { getAuth, GoogleAuthProvider } from "firebase/auth";  
const firebaseConfig = {   
    apiKey: "AIzaSyCGouVYlz3zZEvJa-Sfl2zPNJbm5r3sA3o",   
    authDomain: "olah-aac6b.firebaseapp.com",   
    databaseURL: "https://olah-aac6b-default-rtdb.firebaseio.com",   
    projectId: "olah-aac6b",   
    storageBucket: "olah-aac6b.firebasestorage.app",   
    messagingSenderId: "30842091668",   
    appId: "1:30842091668:web:19542c7533c6e452f21c81",   
    measurementId: "G-KBVKK7S0RD" 
};  

const app = initializeApp(firebaseConfig); 
const analytics = getAnalytics(app); 
const db = getFirestore(app); 
const auth = getAuth(app); 
const googleProvider = new GoogleAuthProvider();  

export { db, auth, googleProvider, analytics }; 